
import { MOCK_SITE_SAMPLE_IDS } from "./constants";

export const getNotificationList = (site) => {
  if (site == MOCK_SITE_SAMPLE_IDS.notification_backup) {
    return notificationData;
  }
  return [];
};

export const getNotificationDetails = (site, id) => {
  return notificationData.find(item => item.id === id);
};

const notificationData = [{
  "id": "96811b10-86e0-49f0-83f6-4bf7736b0f61",
  "display": true,
  "timestamp": 1749705555,
  "resolved_at": null,
  "acknowledged": 1749705534,
  "severity": "notice",
  "name": "Home backup active",
  "description": "Your battery is currently providing backup electricity to your home because the grid connection is unavailable.",
  //"guide": "This is a longer guide about this issue https://empowerenergy.au",
  "faq": [{ "key": "user_guide", "url": "", "description": "Getting started with your Elektrobank 14" }]

}, {
  "id": "96811b10-86e0-49f0-83f6-4bf7736b0f62",
  "timestamp": 1749705550,
  "resolved_at": 1749705538,
  "acknowledged": 1749705534,
  "severity": "critical",
  "name": "System Fault - PV Issue",
  "description": "This is a long notice that we need to share with people"
}, {
  "id": "96811b10-86e0-49f0-83f6-4bf7736b0f63",
  "timestamp": 1749705545,
  "resolved_at": 1749705538,
  "acknowledged": 1749705534,
  "severity": "notice",
  "name": "Welcome to your Elektrobank 14",
  "description": "This is a long notice that we need to share with people"
}];
